import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA (only in production, not on Emergent domain)
if ('serviceWorker' in navigator) {
  const isEmergentDomain = window.location.hostname.includes('emergentagent.com');
  
  // Only register service worker if NOT on Emergent domain
  if (!isEmergentDomain) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
          
          // Check for updates on app start
          const messageChannel = new MessageChannel();
          messageChannel.port1.onmessage = (event) => {
            if (event.data.type === 'UPDATE_CHECK_RESULT') {
              if (!event.data.allFilesPresent) {
                console.warn('Some files are missing. Please check your connection.');
              } else {
                console.log('All files are present and up to date.');
              }
            }
          };
          
          if (registration.active) {
            registration.active.postMessage(
              { type: 'CHECK_FOR_UPDATES' },
              [messageChannel.port2]
            );
          }
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  } else {
    console.log('Running on Emergent platform - Service Worker registration skipped');
    
    // Unregister any existing service workers on Emergent domain
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then(() => {
          console.log('Existing Service Worker unregistered');
        });
      }
    });
  }
}
